export default "__VITE_ASSET__gYdSPK3$__"